// extracted by mini-css-extract-plugin
export default {"cls1":"OverlappingAvatars-cls1___ca5da39f55df086fa11","cls2":"OverlappingAvatars-cls2__ad6b54faa54d95133a71 OverlappingAvatars-cls1___ca5da39f55df086fa11"};